// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"5d4443a9","234":"b09ba546","349":"b1765ab1","541":"31bec15e","810":"5e05b5ad","823":"61ffad8b"}[chunkId] + ".chunk.js";
};